import React, { useState, useContext} from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../AuthContext';
import s from '../styles/login.module.css'; 
import eyeOpenIcon from '../assets/icons/eye_open.svg';
import eyeClosedIcon from '../assets/icons/eye_closed.svg';


function Login() {
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [isRecoveryMode, setIsRecoveryMode] = useState(false);
  const [recoveryEmail, setRecoveryEmail] = useState('');
  const [recoveryError, setRecoveryError] = useState('');
  const [recoveryMessage, setRecoveryMessage] = useState('');
  const navigate = useNavigate();
  const { fetchCurrentUser, isLoggingOut } = useContext(AuthContext);



  
  const handleLogin = async (e) => {
    e.preventDefault(); // Предотвращаем отправку формы
    try {
      const response = await fetch('/api/auth/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({login, password }),
      });

      if (!response.ok) {
        const data = await response.json();
        setError(data.error || 'Login failed');
        return;
      }

      // Если запрос успешен
      const data = await response.json();
      console.log('Login successful:', data);
          // 1) Сохраняем токен в localStorage
     if (data.token) {
       localStorage.setItem('user_token', data.token);
       // Можем также сохранить user_role, если нужно
       localStorage.setItem('user_role', data.user_role);
     }
      // Обновляем данные текущего пользователя
      isLoggingOut.current = false;
      await fetchCurrentUser();
      
      // Перенаправляем пользователя
      navigate('/dashboard');


    } catch (err) {
      setError('Error logging in');
    }
  };

  const handleOpenRecovery = (e) => {
    e.preventDefault();
    setIsRecoveryMode(true);
    setError('');
    setRecoveryError('');
    setRecoveryMessage('');
  };

  const handleRecovery = async (e) => {
    e.preventDefault();
    setRecoveryError('');
    setRecoveryMessage('');

    try {
      const response = await fetch('/api/request-password-reset', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email: recoveryEmail }),
      });

      const data = await response.json();
      if (!response.ok) {
        setRecoveryError(data.error || 'Не удалось отправить письмо.');
        return;
      }

      setRecoveryMessage(data.message || 'Письмо отправлено. Проверьте почту.');
    } catch (err) {
      setRecoveryError('Ошибка соединения. Попробуйте позже.');
    }
  };

  return (

      <div className={s.login_container}>
        <div className={s.login_form}>
          {!isRecoveryMode ? (
            <form className={s.login_form_form} onSubmit={handleLogin}>
              <input
                type="login"
                placeholder="Логин"
                value={login}
                onChange={(e) => setLogin(e.target.value)}
                autoComplete="login"
                required
                className={s.login_form_input}
              />
              <div className={s.input_with_toggle}>
                <input
                  type={showPassword ? 'text' : 'password'}
                  placeholder="Пароль"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  autoComplete="current-password"
                  className={`${s.login_form_input} ${s.login_form_input_password}`}
                />
                <button
                  type="button"
                  className={s.toggle_password_button}
                  onClick={() => setShowPassword((prev) => !prev)}
                  aria-label={showPassword ? 'Скрыть пароль' : 'Показать пароль'}
                  title={showPassword ? 'Скрыть пароль' : 'Показать пароль'}
                >
                  <img
                    src={showPassword ? eyeOpenIcon : eyeClosedIcon}
                    alt=""
                    className={s.toggle_password_icon}
                  />
                </button>
              </div>
              <div className={s.link}>
                <a
                  href="/"
                  onClick={handleOpenRecovery}
                  style={{ color: '#7e7a7a' }}
                >
                  Забыли пароль?
                </a>
              </div>
              <button className={s.login_form_button} type="submit">Войти</button>
              {error && <p className={s.login_form_p}>{error}</p>}
            </form>
          ) : (
            <form className={s.login_form_form} onSubmit={handleRecovery}>
              <input
                type="email"
                placeholder="Email"
                value={recoveryEmail}
                onChange={(e) => setRecoveryEmail(e.target.value)}
                autoComplete="email"
                required
                className={s.login_form_input}
              />
              <button className={s.login_form_button} type="submit">Отправить ссылку</button>

              <button
                type="button"
                className={s.login_form_secondary_button}
                onClick={() => {
                  setIsRecoveryMode(false);
                  setRecoveryError('');
                  setRecoveryMessage('');
                }}
              >
                Назад ко входу
              </button>

              <div className={s.link}>
                <a
                  href="https://t.me/fiveadspro_bot?start=resetpassword"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: '#7e7a7a' }}
                >
                  Или восстановить через Telegram-бота
                </a>
              </div>

              {recoveryError && <p className={s.login_form_p}>{recoveryError}</p>}
              {recoveryMessage && <p className={s.login_form_success}>{recoveryMessage}</p>}
            </form>
          )}
        </div>
      </div>
  );
}

export default Login;
